var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../abstracts/colors';
import { Icon } from '../Icon';
import { a11yBreakpoint } from './variants/DefaultModal/elements';
var ModalDismissButtonElement = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: transparent;\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  border: 0;\n  border-radius: 9999px;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n\n  transition: background-color 0.2s;\n\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n\n  > span {\n    padding: 0.5rem;\n    border-radius: 9999px;\n    box-sizing: content-box;\n  }\n\n  ", "\n"], ["\n  background-color: transparent;\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  border: 0;\n  border-radius: 9999px;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n\n  transition: background-color 0.2s;\n\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n\n  > span {\n    padding: 0.5rem;\n    border-radius: 9999px;\n    box-sizing: content-box;\n  }\n\n  ", "\n"])), colors.neutralBrighter, colors.neutralBright, function (_a) {
    var $actionButtonPresent = _a.$actionButtonPresent;
    return $actionButtonPresent && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media only screen and (", ") {\n        display: none;\n      }\n    "], ["\n      @media only screen and (", ") {\n        display: none;\n      }\n    "])), a11yBreakpoint);
});
export var ModalDismissButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, actionButtonPresent = _a.actionButtonPresent, rest = __rest(_a, ["className", "actionButtonPresent"]);
    return (React.createElement(ModalDismissButtonElement, __assign({ id: "modal-dismiss-button", "aria-label": "close dialog", className: className, "$actionButtonPresent": actionButtonPresent }, rest),
        React.createElement(Icon, { size: "large", src: "CloseX", fill: "black" })));
};
var templateObject_1, templateObject_2;
